// 🔧 index.js
// ✅ Purpose: Entry point for the Event Merch Store Demo Engine
// ✅ Features:
// - Exposes runStoreEngine()
// - Runs Store Builder when Event Merch Store is selected
// - Returns standardized Demo Report v2-compatible results
// - Fully block-commented for clarity and future devs

import { buildStore } from "./store_builder";

export const runStoreEngine = async ({ demoContext } = {}) => {
  console.log("🛒 Store Engine started.");

  const result = await buildStore({ demoContext });

  console.log("✅ Store Engine completed.", { result });

  return result;
};